<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationCode" allowClear :placeholder="language['column.pleaseChoose']+language['premission.applicationName']">
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.applicationCode">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.publisher']">
              <a-input :placeholder="language['announcement.mustPublisher']" v-model="queryParam.sender"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.msgCategory']">
              <a-select
                v-model="queryParam.msgCategory"
                :placeholder="language['common.pleaseChoose']+language['announcement.msgCategory']"
                allowClear>
                <a-select-option value="1">{{language['announcement.notification']}}</a-select-option>
                <a-select-option value="2">{{language['announcement.systemMessages']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['announcement.header']">
                <a-input :placeholder="language['announcement.mustHeader']" v-model="queryParam.titile"></a-input>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8" >
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" @click="readAll" icon="book">{{language['announcement.readAll']}}</a-button>
    </div>

    <a-table
      ref="table"
      size="default"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange">
      <span slot="action" slot-scope="text, record">
        <a @click="showAnnouncement(record)">{{language['common.look']}}</a>
      </span>

      <span slot="msgCategory" slot-scope="text, record">
        {{ text === '1' ? language["announcement.notification"] : (text === '2'?language["announcement.systemMessages"]:text) }}
      </span>
      <span slot="priority" slot-scope="text, record">
        {{ text === 'H' ? language['common.high'] : (text === 'M'?language['common.middle']:(text==='L'?language['common.low']:text)) }}
      </span>
      <span slot="readFlag" slot-scope="text, record">
        {{ text === '0' ? language['announcement.messageUnRead'] : (text === '1'?language['announcement.messageRead']:text) }}
      </span>

    </a-table>
    <show-announcement ref="ShowAnnouncement"></show-announcement>
    <dynamic-notice ref="showDynamNotice" :path="openPath" :formData="formData"/>
  </a-card>
</template>

<script>
  import { filterObj } from '@/utils/util'
  import { getAction,putAction,httpAction  } from '@/api/manage'
  import ShowAnnouncement from '@/components/tools/ShowAnnouncement'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import DynamicNotice from '../../components/tools/DynamicNotice'

  export default {
    name: "UserAnnouncementList",
    mixins: [JeecgListMixin],
    components: {
      DynamicNotice,
      ShowAnnouncement
    },
    data () {
      return {
        queryParam: {},
        applicationList:[],
        application:{},
		    url: {
          list: this.$store.getters.application.applicationType=='platform'?"/sys/sysAnnouncementSend/getMyAnnouncementSend":"/sys/sysAnnouncementSend/getMyAnnouncementSend?applicationCode="+this.$store.getters.applicationCode,
          editCementSend:"sys/sysAnnouncementSend/editByAnntIdAndUserId",
          // readAllMsg:"sys/sysAnnouncementSend/readAll",
          readAllMsg:this.$store.getters.application.applicationType=='platform'?"/sys/sysAnnouncementSend/readAll":"/sys/sysAnnouncementSend/readAll?applicationCode="+this.$store.getters.applicationCode,
        },
        loading:false,
        openPath:'',
        formData:'',
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        columns:[{
          title: this.$store.getters.language['announcement.header'],
          align:"center",
          dataIndex: 'titile',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },{
          title: this.$store.getters.language['announcement.msgCategory'],
          align: "center",
          dataIndex: 'msgCategory',
          scopedSlots: {customRender: 'msgCategory'},
        },{
          title: this.$store.getters.language['announcement.publisher'],
          align:"center",
          dataIndex: 'sender',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },{
          title: this.$store.getters.language['announcement.publishTime'],
          align:"center",
          dataIndex: 'sendTime'
        },{
          title: this.$store.getters.language['announcement.priority'],
          align:"center",
          dataIndex: 'priority',
          scopedSlots: {customRender: 'priority'},
        },{
          title: this.$store.getters.language['announcement.readFlag'],
          align:"center",
          dataIndex: 'readFlag',
          scopedSlots: {customRender: 'readFlag'},
        },{
          title: this.$store.getters.language['common.action'],
          dataIndex: 'action',
          align:"center",
          scopedSlots: { customRender: 'action' },
        }]
      }
    },
    created () {
      this.application = this.$store.getters.application;
      if(this.application.applicationType === 'platform') {
        this.getApplicationList();
      }
      console.log('applicationCode:'+this.$store.getters.applicationCode)
      console.log('applicationtype:'+this.$store.getters.application.applicationType)
      // this.getThisapplication();
      getAction("/sys/sysleveldataconfigs/getDataByEntity",{applicationId:this.application.id,dataTypeCode:'announcement_management',parentCode:'1,2'}).then(res=>{
        if(res.success){
          let value = {
            title: this.$store.getters.language['announcement.secondMsgCategory'],
            align: "center",
            dataIndex: 'secondMsgCategoryName',
          }
          this.columns.splice(2,0,value);
        }
      })
    },
    computed: {
      language() {
        return this.$store.getters.language
      },

    },
    methods: {
      getApplicationList(){
        httpAction("/sys/sysBmApplication/queryList", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
      handleDetail: function(record){
        this.$refs.sysAnnouncementModal.detail(record);
        this.$refs.sysAnnouncementModal.title=this.language["common.look"];
      },
      showAnnouncement(record){
        putAction(this.url.editCementSend,{anntId:record.anntId}).then((res)=>{
          if(res.success){
            this.loadData();
            this.syncHeadNotic(record.anntId)
          }
        });
        if(record.openType==='component'){
          this.openPath = record.openPage;
          this.formData = {id:record.busId};
          this.$refs.showDynamNotice.detail();
        }else{
          this.$refs.ShowAnnouncement.detail(record,'UserAnnouncementlist');
        }
      },
      syncHeadNotic(anntId){
        getAction("sys/annountCement/syncNotic",{anntId:anntId})
      },
      readAll(){
        var that = this;
        that.$confirm({
          title:this.language["confirm.titleConfirmOperation"],
          content:this.language["system.whetherAllReaded"],
          onOk: function(){
            if(that.queryParam.applicationCode){
              that.url.readAllMsg = "/sys/sysAnnouncementSend/readAll?applicationCode="+that.queryParam.applicationCode
            }
            getAction(that.url.readAllMsg).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.syncHeadNotic();
              }
            });
          }
        });
      },
    }
  }
</script>
<style scoped>
  .ant-card-body .table-operator{
    margin-bottom: 18px;
  }
  .anty-row-operator button{margin: 0 5px}
  .ant-btn-danger{background-color: #ffffff}z

  .ant-modal-cust-warp{height: 100%}
  .ant-modal-cust-warp .ant-modal-body{height:calc(100% - 110px) !important;overflow-y: auto}
  .ant-modal-cust-warp .ant-modal-content{height:90% !important;overflow-y: hidden}
</style>